// Flag-gated MSW starter. The mock serves screens from the local JSON seed for
// frontend-only work (change build-poc-screens). It is **opt-in**: MSW runs ONLY
// when VITE_MOCK_DATA === 'true'. Any SST-connected stage (dev/angel/prod) sets
// VITE_API_URL to a real API and does NOT set the flag, so the app always hits
// the live backend — no dual-backend ambiguity. Never runs in a production build
// (import.meta.env.DEV is compile-time false, so the worker/handlers tree-shake out).
export async function startMocks(): Promise<void> {
	const enabled = import.meta.env.DEV && import.meta.env.VITE_MOCK_DATA === 'true'
	if (!enabled) return
	const { worker } = await import('./browser')
	await worker.start({ onUnhandledRequest: 'bypass' })
}
